import type { NotificationCategory, NotificationListResponse, NotificationSettingsResponse } from '@yana/shared';
import { api } from '@/api/client';

export function listNotifications(params: {
  category: NotificationCategory;
  unreadOnly: boolean;
  limit: number;
  offset: number;
}): Promise<NotificationListResponse> {
  const query = new URLSearchParams({
    category: params.category,
    unreadOnly: String(params.unreadOnly),
    limit: String(params.limit),
    offset: String(params.offset),
  });
  return api.get<NotificationListResponse>(`/notifications?${query}`);
}

export const markNotificationRead = (id: string) => api.patch<{ ok: true }>(`/notifications/${id}/read`);
export const markAllNotificationsRead = () => api.post<{ ok: true }>('/notifications/read-all');
export const getNotificationSettings = () => api.get<NotificationSettingsResponse>('/settings/notifications');
export async function saveNotificationSettings(settings: NotificationSettingsResponse['notifications']): Promise<NotificationSettingsResponse> {
  const response = await api.put<NotificationSettingsResponse>('/settings/notifications', settings);
  notifyNotificationSettingsChanged(response);
  return response;
}

// Both the bell's quick actions and the general settings publish the saved value.
// Mounted consumers can update immediately without racing a second settings GET.
export function notifyNotificationSettingsChanged(settings: NotificationSettingsResponse): void {
  window.dispatchEvent(new CustomEvent<NotificationSettingsResponse>('notification-settings-changed', {
    detail: { notifications: { ...settings.notifications }, canViewLogins: settings.canViewLogins },
  }));
}
